module.exports = __webpack_public_path__ + "img/swiftForm.a9c8364a.svg";